/* tslint:disable */
/* eslint-disable */
/**
 * ConfigHub API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PropertyType {
    Integer = 'Integer',
    Boolean = 'Boolean',
    Text = 'Text',
    List = 'List'
}

export function PropertyTypeFromJSON(json: any): PropertyType {
    return PropertyTypeFromJSONTyped(json, false);
}

export function PropertyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyType {
    return json as PropertyType;
}

export function PropertyTypeToJSON(value?: PropertyType | null): any {
    return value as any;
}

